import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, StateUtils, submissionViewModel, QuestionSetService) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    ctrl.init = function () {
        $scope.validationMsg = false;
        $scope.questionSets = submissionVM.lobData.workersComp.generalInfoQuestionSets.value;
        $scope.questions = QuestionSetService.getQuestionSetViewModel($scope.questionSets);
        console.log('customer WCGeneralInfoQuestioinsCtrl' + submissionVM.baseData.mSFGeneralInfoQue_EXT.value);
        console.log(submissionVM.value);
    };

    ctrl.next = function (nextFn, form) {
        // prequal question requiredness not captured in the submission model, so pass form validity for isValid check
        $scope.validationMsg = false;

        angular.forEach($scope.questions, function (item1) {
            angular.forEach(item1.questions, function (item2, index) {

                if (item2 != undefined && item2 != null && item2.type != "SELECT" && item2.code != 'z0giie47dg57j091efrr7h8dv59') {
                    if (item2.answer == null && item2.aspects.visible == true) {
                        $scope.validationMsg = true;
                    }
                    if (item2.answer != undefined && item2.answer != null && item2.aspects.visible == true) {
                        if (String(item2.answer).trim() == '') {
                            $scope.validationMsg = true;
                        }
                        if (item2.type == "RADIO" && String(item2.answer).trim() == 'dummy') {
                            $scope.validationMsg = true;
                        }
                    }
                }
            });
        });

        if ($scope.validationMsg == true) {
            // return false;
            // nextFn(submissionVM, false);  
        } else {
            // var selectedValue=angular.element('select[name="Answer9"]').val();
            // if(selectedValue!=undefined && String(selectedValue).trim()=='') {
            // submissionVM.lobData.workersComp.preQualQuestionSets.value[0].answers.zfth2jtgspfa7fa644mfb7ltf79=null;
            // }
            submissionVM.baseData.mSFGeneralInfoQue_EXT.value = true;
            nextFn(submissionVM, form.valid);
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel', 'QuestionSetService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/controllers/WCGeneralInfoQuestionsCtrl.js
// module id = 1295
// module chunks = 0